import { render, staticRenderFns } from "./MailSentInfoCreate.vue?vue&type=template&id=4beef842&"
import script from "./MailSentInfoCreate.vue?vue&type=script&lang=ts&"
export * from "./MailSentInfoCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports